module.exports = __webpack_public_path__ + "files/084d3654b746be58c4ead97c26d16be2.png";


//////////////////
// WEBPACK FOOTER
// ./images/logo_compact.png
// module id = 575
// module chunks = 60